import type { ComponentProps } from "react";
import type { Badge } from "@/components/ui/badge";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

// Statuses map 1:1 to the inbound_emails projection: a routed email is linked
// to a site, received means linked to a known sender but no site yet, and
// unresolved means neither matched.
export function inboundEmailStatusLabel(status: string): string {
  switch (status) {
    case "routed":
      return "Routed";
    case "received":
      return "Maybe received";
    case "unresolved":
      return "Unresolved";
    default:
      return status;
  }
}

export function classificationLabel(
  classification: string | null | undefined
): string | null {
  if (!classification) return null;
  switch (classification) {
    case "sign_in_query":
      return "Sign-in query";
    case "compliance_document":
      return "Compliance document";
    case "site_enquiry":
      return "Site enquiry";
    case "incident_report":
      return "Incident report";
    case "worker_request":
      return "Worker request";
    case "other":
      return "Other";
    default:
      return null;
  }
}

export function inboundEmailStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case "routed":
      return "default";
    case "unresolved":
      return "destructive";
    default:
      return "secondary";
  }
}
